module.exports = __webpack_public_path__ + "static/media/3DPPA32.48d04466.jpg";